// extracted by mini-css-extract-plugin
export default {"Price":"CurrentPrice_Price__VpRU4","Price__Text":"CurrentPrice_Price__Text__YzBU8","Value":"CurrentPrice_Value__9wW6F","unit":"CurrentPrice_unit__U4JYc"};